import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0


import { isFunction } from '@polkadot/util';
import { combineLatest, of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs"; // eslint-disable-next-line @typescript-eslint/no-unused-vars

function isNewDepositors(depositors) {
  // Detect balance...
  // eslint-disable-next-line @typescript-eslint/unbound-method
  return isFunction(depositors[1].mul);
}

function parse(_ref) {
  var _ref2 = _slicedToArray(_ref, 3),
      proposals = _ref2[0],
      images = _ref2[1],
      optDepositors = _ref2[2];

  return proposals.filter(function (_ref3, index) {
    var _ref4 = _slicedToArray(_ref3, 3),
        proposer = _ref4[2];

    var _optDepositors$index;

    return !!((_optDepositors$index = optDepositors[index]) !== null && _optDepositors$index !== void 0 && _optDepositors$index.isSome) && !proposer.isEmpty;
  }).map(function (_ref5, proposalIndex) {
    var _ref6 = _slicedToArray(_ref5, 3),
        index = _ref6[0],
        imageHash = _ref6[1],
        proposer = _ref6[2];

    var depositors = optDepositors[proposalIndex].unwrap();
    return _objectSpread(_objectSpread({}, isNewDepositors(depositors) ? {
      balance: depositors[1],
      seconds: depositors[0]
    } : {
      balance: depositors[0],
      seconds: depositors[1]
    }), {}, {
      image: images[proposalIndex],
      imageHash: imageHash,
      index: index,
      proposer: proposer
    });
  });
}

export function proposals(instanceId, api) {
  return memo(instanceId, function () {
    var _api$query$democracy, _api$query$democracy2;

    return (_api$query$democracy = api.query.democracy) !== null && _api$query$democracy !== void 0 && _api$query$democracy.publicProps && (_api$query$democracy2 = api.query.democracy) !== null && _api$query$democracy2 !== void 0 && _api$query$democracy2.preimages ? api.query.democracy.publicProps().pipe(switchMap(function (proposals) {
      return combineLatest([of(proposals), api.derive.democracy.preimages(proposals.map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            hash = _ref8[1];

        return hash;
      })), api.query.democracy.depositOf.multi(proposals.map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 1),
            index = _ref10[0];

        return index;
      }))]);
    }), map(parse)) : of([]);
  });
}